import React from 'react';
import './mapPie.css';
import { mapMeteocodeDataColors } from '../utilts';

export type MapPiePart = {
  meteocode: string
  value: string
  unit?: string
  meteocodeName?: string
}

type MapPieProps = {
  values: MapPiePart[]
  size?: number
}

type MapPiePartWithCoords = MapPiePart & {
  x: number
  y: number
}

function MapPieDefault({ values = [], size = 128 }: MapPieProps) {
  const cellSize = size / 3;

  const layout = React.useMemo(() => {
    const angle = 360 / values.length;
    const r = size / 3.5;

    const cx = size / 2;
    const cy = size / 2;

    let startAngle = -90;

    const rad = Math.PI / 180;

    const tmp: MapPiePartWithCoords[] = [];

    values.forEach((value: MapPiePart) => {
      const x = cx + r * Math.cos(startAngle * rad) - (cellSize / 2);
      const y = cy + r * Math.sin(startAngle * rad) - (cellSize / 2);
      startAngle += angle;

      tmp.push({ ...value, x, y });
    });
    return tmp;
  }, [cellSize, values, size]);

  return (
    <div
      className="map-pie-wrapper"
      style={{
        width: size,
        height: size,
      }}
    >
      <div className="map-pie-hexagon" />
      {
        layout.map((value, index) => (
          <Element
            key={value.meteocode}
            value={value}
            cellSize={cellSize}
            index={index}
          />
        ))
      }
    </div>
  );
}

export const MapPie = React.memo(MapPieDefault);
MapPie.displayName = 'MapPie';

type ElementProps = {
  value: MapPiePartWithCoords
  cellSize: number
  index: number
}

function Element({ value, cellSize, index }: ElementProps) {
  return (
    <div
      className="map-pie-item"
      style={{
        top: value.y,
        left: value.x,
        width: cellSize,
        height: cellSize,
        backgroundColor: mapMeteocodeDataColors[index],
        color: 'white',
        pointerEvents: value ? 'all' : 'none',
      }}
    >
      {value && (
        <span
          className="map-pie-item-content"
        >
          <p>
            {`${value.value} `}
            <sup className="map-pie-item-value-unit">{value.value && value.unit}</sup>
          </p>
          <p className="map-pie-item-meteocode-name">{value.meteocodeName}</p>
        </span>
      )}
    </div>
  );
}
